import React from 'react'
import PropTypes from 'prop-types'
import { orderBy } from 'lodash'
import { Box, Grid, Flex } from '@chatterbug/aaron'
import { Button } from '@chatterbug/theme'

import { t } from 'src/lib/i18n-react'

import FilterItem from './subcomponents/FilterItem'

const Filter = ({
  onFilterChange,
  onReset,
  tutors,
  checkedCount,
  onApplyFilters,
  filterRef,
}) => {
  const handleFilterChange = (event) => {
    onFilterChange(event.target.checked, event.target.id)
  }

  const sortedTutors = orderBy(tutors, 'isFavorite', 'desc')

  return (
    <Flex
      ref={filterRef}
      flexDirection="column"
      bg="white100"
      overflowY="hidden"
      sx={{ position: 'relative' }}
    >
      <Box
        as="form"
        onSubmit={onApplyFilters}
        sx={{ position: 'relative', flexShrink: '0' }}
      >
        <Box as="fieldset">
          <Box px="3x" overflowY="scroll" minHeight="auto" maxHeight="450px">
            {sortedTutors.map((tutor, index) => (
              <FilterItem
                key={index}
                handleChange={handleFilterChange}
                {...tutor}
              />
            ))}
          </Box>
        </Box>
        <Grid
          bg="white100"
          sx={{
            borderTopWidth: 'small',
            borderTopColor: 'gray88',
            borderTopStyle: 'solid',
            position: 'sticky',
            bottom: '0',
          }}
        >
          <Grid
            gridTemplateColumns={'repeat(2, 1fr)'}
            gridGap="1x"
            px="2x"
            py="3x"
          >
            <Button as="submit" type="submit" disabled={checkedCount < 1}>
              {t('Done')}
            </Button>
            <Box
              as="span"
              display={checkedCount > 0 ? 'flex' : 'none'}
              width="100%"
              flexDirection="column"
            >
              <Button as="submit" kind="tertiary" onClick={onReset}>
                {t('Clear all')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Flex>
  )
}

Filter.propTypes = {
  tutors: PropTypes.array,
  onFilterChange: PropTypes.func,
  checkedCount: PropTypes.number,
  onReset: PropTypes.func.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  filterRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
}

export default Filter
